import { initValidate } from 'libs/validate'
import { useRef, useState, useEffect } from 'preact/hooks'
import { emitterProps, globalEmitter } from 'helpers/emitter-event'
import { hideModal, on, select } from 'helpers/dom'
import { clearCart } from 'libs/cart'
import TextInput from 'snippets/form/text-input/text-input'
import Textarea from 'snippets/form/text-input/textarea'
import Icon from 'snippets/icon/icon'
import { getQuouteProduct } from 'snippets/quote/utils'

const selectors = {
  ELEMENT_TAG: 'input',
  ELEMENT_TYPE: 'hidden',
  MODAL_SELECTOR: 'modal-dialog[data-target="modal-quote"]',
  MODAL_QUOTE_ID: 'modal-quote',
  DELAY_TIME: 20,
  TIME_OUT: 100
}

function QuoteForm({ type, id }) {
  const productQuote = type === 'product'
  const formRef = useRef(null)
  const [isLoading, setIsLoading] = useState(false)
  const [formValidated, setFormValidated] = useState(null)
  const [isError, setIsError] = useState(false)

  const timer = (ms) => new Promise((resolve) => setTimeout(resolve, ms))

  const initProduct = (products) => {
    GRFQConfigs.productInfo = {
      listProducts: getQuouteProduct(products),
      productGroup: [
        {
          title: 'product',
          group_id: 0,
          item: products.map((product) => product.id)
        }
      ]
    }
  }

  const addQuote = async (e) => {
    const products = [...GM_STATE.cart.initCart.items]

    if (productQuote) {
      const { initProduct: currentProduct } = productState
      const currentVariantId = new URLSearchParams(location.search).get('variant')
      const currentVariant = currentProduct.variants.find((variant) => variant.id === Number.parseInt(currentVariantId))

      products.push({
        id: currentProduct.id,
        title: currentProduct.title,
        vendor: currentProduct.vendor,
        variant_id: new URLSearchParams(location.search).get('variant'),
        variant_title: currentVariant.title,
        image: `${Shopify.shop}${currentProduct.featuredImage.src}`,
        url: currentProduct.url,
        quantity: select('input[type="number"]')?.value || 1,
        price: currentProduct.price
      })
    }

    GRFQApp.removeQuotes()

    initProduct(products)

    submitForm(e)
  }

  const submitForm = async (e) => {
    setIsLoading(true)
    await timer(selectors.TIME_OUT)

    try {
      GRFQApp.popup.safeFormData = new FormData(formRef.current)

      await GRFQApp.popup.submitQuote(e.target)

      handleSuccess()
      setIsError(false)

      if (GM_STATE.cart.quoteClear) {
        await clearCart()
      }

      const modalEl = select(selectors.MODAL_SELECTOR)

      if (modalEl) {
        on(
          'close-modal',
          () => {
            formRef.current.reset()
          },
          modalEl
        )
      }
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error('Form submission failed:', error)
      setIsError(true)
    } finally {
      setIsLoading(false)
    }
  }

  const handleSuccess = () => {
    hideModal(selectors.MODAL_QUOTE_ID)
    globalEmitter.emit(emitterProps.notice.global, {
      type: 'success',
      content: 'Requested a quote successfully'
    })
    formRef.current.reset()
  }

  const handleSubmit = async (e) => {
    e.preventDefault()

    await GRFQApp.openQuotePopup()

    if (GRFQApp.popup) addQuote(e)
  }

  useEffect(() => {
    const formValidated = initValidate(formRef.current, true)

    setFormValidated(formValidated)
  }, [])

  useEffect(() => {
    if (!formValidated) return

    const modalQuoteEl = select(`#${selectors.MODAL_QUOTE_ID}`)

    on(
      'close-modal',
      () => {
        formRef.current.reset()
        formValidated.refresh()
      },
      modalQuoteEl
    )

    formValidated.onSuccess(handleSubmit)
  }, [formValidated, type])

  return (
    <>
      <p class='text-center mb-4'>{translate.cart.existing_b2b} <a class='underline' href="https://www.aidacare.com.au/multiloginpage/">{translate.cart.click_here}</a></p>
      <form ref={formRef} class="rfq-product-form flex flex-col gap-4">
        {isError && (
          <div className="notice-main relative">
            <div className="absolute left-0 -ml-px h-full min-w-1.5 rounded-l bg-error-content"></div>
            <Icon className="size-8 flex-shrink-0 text-error-content" name="icon-error" viewBox="0 0 32 32" />
            <div className="notice-main-content pl-4">{translate.cart.errorForm}</div>
          </div>
        )}
        <TextInput
          classWrap="w-full"
          type="text"
          id="quote-customer-name"
          placeholder="Customer name"
          autocomplete={true}
          name="name"
          required
        />
        <TextInput
          classWrap="w-full"
          type="email"
          id="quote-customer-email"
          placeholder="Customer email"
          autocomplete={true}
          name="email"
          required
        />
        <TextInput
          classWrap="w-full"
          type="tel"
          id="quote-customer-phone"
          placeholder="Contact Phone Number"
          autocomplete={true}
          name="Phone"
          required
        />
        <TextInput
          classWrap="w-full"
          type="text"
          id="quote-company"
          placeholder="Company"
          autocomplete={true}
          name="company"
        />
        <TextInput
          classWrap="w-full"
          type="text"
          id="quote-customer-shipping-address"
          placeholder="Shipping Address"
          autocomplete={true}
          name="Shipping Address"
          required
        />
        <TextInput
          classWrap="w-full"
          type="text"
          id="quote-ndis-number"
          placeholder="NDIS Number"
          autocomplete={true}
          name="NDIS Number"
        />
        <Textarea
          classWrap="w-full"
          className="min-h-[120px]"
          type="textarea"
          id="quote-comments"
          placeholder="Comments"
          autocomplete={true}
          name="message"
          required
        />
        <button type="submit" className={`rfq-btn !button-primary w-full ${isLoading && 'pointer-events-none'}`}>
          {isLoading ? 'Submitting' : 'Send Quote Request'}
        </button>
        <button type="reset" onClick={() => hideModal(id)} className="button-outlined w-full">
          {translate.cart.cancel}
        </button>
      </form>
    </>
  )
}

export default QuoteForm
